import { render, staticRenderFns } from "./ScheduleChartLegend.vue?vue&type=template&id=54ba7b7a&scoped=true&"
import script from "./ScheduleChartLegend.vue?vue&type=script&lang=js&"
export * from "./ScheduleChartLegend.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleChartLegend.vue?vue&type=style&index=0&id=54ba7b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba7b7a",
  null
  
)

export default component.exports